import { validateState } from "@hagerty/self-service-components/api/utils";
import { getStateName, PolicyDetails } from "shared";
import { IdCard } from "../../../svg";
import { useDialog } from "../../Dialog";
import { useState } from "react";
import { CompOnlyDialog } from "../../Insurance/CompOnlyDialog";
import { getVehiclesLabel } from "../../../utils/vehicleUtils";
import { mt } from "../../../utils/tracking";
import { useUrls } from "../../../app/Providers/AppContext";
import { Tile } from "../../Tile";

import styles from "./PolicyTiles.module.scss";

type IdCardTileProps = {
  policy: PolicyDetails;
};

export const IdCardTile = ({ policy }: IdCardTileProps) => {
  const urls = useUrls();
  const [isRedirecting, setIsRedirecting] = useState(false);
  const vehicleNamesLabel = getVehiclesLabel(policy.vehicles);
  const compOnlyDialog = useDialog();

  return (
    <>
      <Tile
        icon={<img src={IdCard} alt="ID Card" aria-hidden="true" />}
        className={styles.tile}
        cta="ID Card"
        ariaLabel={`Access Insurance ID for your ${vehicleNamesLabel} on policy ${policy.policyNumber}`}
        tagAction={{
          actionName: "ID Card",
          actionType: "link",
        }}
        href={policy.hasIdCard ? urls.insurance.idCardPage : undefined}
        onClick={() =>
          policy.hasIdCard ? setIsRedirecting(true) : compOnlyDialog.open()
        }
        isLoading={isRedirecting}
      />

      {compOnlyDialog.isOpen && (
        <CompOnlyDialog
          policyName={getStateName(validateState(policy.stateRegion))}
          compOnlyType={policy.compOnlyType ?? "STANDARD"}
          onClose={() => {
            mt.trackPopupClose();
            compOnlyDialog.close();
          }}
        />
      )}
    </>
  );
};
